module.exports = __webpack_public_path__ + "img/ml3085.69355339.png";